// do not use the id 'test' for a slide
$(document).ready(function () {
	var videoSlide = {
		type: 'video',
		navElements: ['video-home'],
		nextAction: function () {
			completeSlide();
			jumpToId('menu');
		},
		videoLoaded: false //don't edit
	};

	var modals = {
		modal: function (slide) {
			return {
				positive: slide.id + '-positive',
				negative: slide.id + '-negative',
				negativeFinal: slide.id + '-negative-final'
			};
		}
	};

	var dynamicHotspotModals = {
		modal: function (slide) {
			var modalObj = {};
			var $hotspots = slide.$.find('.hotspot-button__js');
			var styleLabel = slide.data.styleLabel || slide.id;

			$hotspots.each(function (idx, hotspot) {
				var itemNum = idx + 1;
				modalObj['hs' + itemNum] = styleLabel + '-hs' + itemNum;
			});

			return modalObj;
		}
	};

	slides = {
		start: {
			type: 'text',
			navElements: ['start-slide'],
			backAction: function (slide) {}, //leave Start backAction as function to prevent IE9 errors
			onEnterAction: function (slide) {},
			audio: {
				onEnter: 'media/audio/vo/start.mp3'
			},
			include: false // this key determines if the slide will be used as part of the completion of the progress meter. default is true.  do not call completeSlide() on any slide where this is set to false
		},
		menu: {
			type: 'menu',
			menu: {
				linear: false,
				menuClass: 'si-menu__js',
				navigation: ['v1', 'i1', 'v2', 'v3', 'v4', 'v5', 'v6'],
				completionIDs: ['v1', 'i1', 'v2', 'v3', 'v4', 'v5', 'i2']
			},
			onEnterAction: function (slide) {
				if (!slide.data.visited) {
					$('#menu .si-menu__js').on('click', function (e) {
						$(this).addClass('completed');
					});
				} else {
					siAudio.menu.onEnter = new Howl({
						src: ['media/audio/sounds/nothing.mp3']
					});
				}
			},
			audio: {
				onEnter: 'media/audio/vo/menu.mp3'
			},
			include: false
		},
		v1: {
			groups: videoSlide,
			nextAction: function () {
				completeSlide();
				jumpToId('menu');
			}
		},
		i1: {
			groups: [dynamicHotspotModals, modals],
			type: 'hotspot',
			navElements: ['home'],
			nextAction: function (slide) {
				completeSlide();
				jumpToId('menu');
			},
			backAction: function (slide) {
				jumpToId('menu');
			},
			onEnterAction: function (slide) {},
			hotspot: {
				onWin: function () {
					handleAnswer(true);
				},
				onClick: function ($hotspot, $modal) {
					var mythVideo = $modal.find('.myth');

					mythVideo[0].play();
				},
				onModalClose: function ($hotspot, $modal) {
					var mythVideo = $modal.find('.myth');

					mythVideo[0].pause();
					mythVideo[0].currentTime = 0;
				}

				// audio: {
				// 	1: 'media/audio/vo/i1.1.mp3',
				// 	2: 'media/audio/vo/i1.2.mp3',
				// 	3: 'media/audio/vo/i1.3.mp3',
				// 	4: 'media/audio/vo/i1.4.mp3',
				// 	5: 'media/audio/vo/i1.5.mp3'
				// }
			},
			audio: {
				onEnter: 'media/audio/vo/i1.mp3',
				positive: 'media/audio/vo/i1p.mp3'
			}
		},
		v2: {
			groups: videoSlide
		},
		v3: {
			groups: videoSlide
		},
		v4: {
			groups: videoSlide
		},
		v5: {
			groups: videoSlide
		},
		v6: {
			groups: videoSlide,
			nextAction: function () {
				completeSlide();
				jumpToId('i2');
			}
		},
		i2: {
			navElements: ['submit', 'home'],
			groups: [modals],
			type: 'quiz',
			nextAction: function () {
				completeSlide();
				nextSlide();
			},
			quiz: {
				answers: {
					'i2-correct1': 1,
					'i2-correct2': 1,
					'i2-correct3': 1,
					'i2-correct4': 1
				},
				userAttempts: 2
			},
			audio: {
				onEnter: 'media/audio/vo/i2.mp3',
				positive: 'media/audio/vo/i2p.mp3',
				negative: 'media/audio/vo/i2n.mp3',
				negativeFinal: 'media/audio/vo/i2nn.mp3'
			}
		},
		end: {
			type: 'text',
			navElements: ['replay'],
			backAction: prevSlide,
			nextAction: function (slide) {},
			onEnterAction: function (slide) {
				// Do not check for "lmsConnected", because that's done in setScormCompletion() anyways and AICC wouldn't work anymore.
				setScormCompletion();
			},
			audio: {
				onEnter: 'media/audio/vo/end.mp3'
			},
			include: false
		}
	};
});
